<template>
  <div class="hign-search-modal">
    <el-dialog :visible.sync="hignModalVisible" width="613px" :before-close="handleClose" :close-on-click-modal="closeonclickmodal" v-el-drag-dialog>
      <div slot="title" class="search-modal-title">
        <span class="modal-title-span">{{modalTitle}}</span>
      </div>
      <el-form :model="form" ref="reasonList" :show-message="false" @validate="validateTwo">
        <div class="search-modal-content" v-for="(item, index) in form.reasonList" :key="index">
          <el-form-item
            class="modal-content-form-item"
            :prop="'reasonList.'+ index + '.oneS'"
            :rules="{
              required: true,
              message: `请选择`,
              trigger: 'change'
            }">
            <el-select class="content-select-one" v-model="item.oneS" placeholder="请选择" @change="changeOnes(item)">
              <el-option :label="items.column" :value="items.caseKey" v-for="(items, indexs) in hignOneList" :key="indexs"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="modal-content-form-item"
            :prop="'reasonList.'+ index + '.twoS'"
            :rules="{
              required: true,
              message: `请选择`,
              trigger: 'change'
            }">
            <el-select class="content-select-two" v-model="item.twoS" placeholder="请选择" @change="changeTwos(item)" :disabled="item.getDicUrl ? true : false">
              <el-option :label="itemT.twoLabel" :value="itemT.twoValue" v-for="(itemT, indexT) in twoList" :key="indexT"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="modal-content-form-item"
            v-if="item.choose.needInput == true"
            :prop="'reasonList.'+ index + '.threeS'"
            :rules="{
              required: true,
              message: `请输入`,
              trigger: 'change'
            }">
            <key-value-select
              v-if="item.getDicUrl && !Array.isArray(item.getDicUrl)"
              class="content-select-one"
							:className="'import-input'"
							v-model="item.threeS"
							placeholder="请选择"
							:dictUrl="item.getDicUrl"
						></key-value-select>
            <el-select class="content-select-one" v-else-if="item.getDicUrl && Array.isArray(item.getDicUrl)" v-model="item.threeS">
              <el-option :label="itemS.label" :value="itemS.value" v-for="(itemS, indexS) in item.getDicUrl" :key="indexS"></el-option>
            </el-select>
            <el-input v-else class="content-select-one" v-model.trim="item.threeS" :maxlength="30" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item
            v-if="item.fourS"
            class="modal-content-form-item"
            :prop="'reasonList.'+ index + '.fourS'"
            :rules="{
              required: true,
              message: `请选择`,
              trigger: 'change'
            }">
            <el-select class="content-select-two" v-model="item.fourS" placeholder="请选择">
              <el-option :label="itemF.fourLabel" :value="itemF.fourValue" v-for="(itemF, indexF) in fourList" :key="indexF"></el-option>
            </el-select>
          </el-form-item>
          <div class="modal-content-icon">
            <el-button class="content-icon-del" icon="el-icon-minus" @click="delItem(item)" v-if="form.reasonList.length !== 1"></el-button>
            <el-button class="content-icon-add" icon="el-icon-plus" @click="addItem" v-if="!item.fourS"></el-button>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="search-modal-footer">
        <span class="hign-footer-notice" v-if="modalTitle === '高级检索'">高级检索与列表常用检索互不影响，只有一个生效</span>
        <el-button class="modal-footer-two" @click="closeHSearch">取消</el-button>
        <el-button class="modal-footer-two" type="default" @click="resetHSearch">重置</el-button>
        <el-button class="modal-footer-two" type="primary" @click="agreeHSearch">搜索</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'hignModal',
  props: {
    hignModalVisible: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: '高级检索'
    },
    hignOneList: {
      type: Array,
      default() {
        return []
      }
    }, // 列名下拉条件
    //是否点击空白处关闭弹窗
    closeonclickmodal:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        reasonList: [
          {
            oneS: '',
            twoS: 'like',
            threeS: '',
            fourS: '',
            getDicUrl: '',
            choose: {
              needInput: true
            }
          }
        ] // 搜索条件
      },
      twoList: [
        {
          twoLabel: 'like',
          twoValue: 'like',
          needInput: true
        },
        {
          twoLabel: 'not like',
          twoValue: 'not like',
          needInput: true
        },
        {
          twoLabel: '=',
          twoValue: '=',
          needInput: true
        },
        {
          twoLabel: '!=',
          twoValue: '!=',
          needInput: true
        },
        {
          twoLabel: '>',
          twoValue: '>',
          needInput: true
        },
        {
          twoLabel: '>=',
          twoValue: '>=',
          needInput: true
        },
        {
          twoLabel: '<',
          twoValue: '<',
          needInput: true
        },
        {
          twoLabel: '<=',
          twoValue: '<=',
          needInput: true
        },
        {
          twoLabel: 'is null',
          twoValue: `is null`,
          needInput: false
        },
        {
          twoLabel: 'is not null',
          twoValue: `is not null`,
          needInput: false
        },
        {
          twoLabel: '为空',
          twoValue: `= ''`,
          needInput: false
        },
        {
          twoLabel: '不为空',
          twoValue: `!= ''`,
          needInput: false
        }
      ], // 条件
      fourList: [
        {
          fourLabel: 'and',
          fourValue: 'and'
        },
        {
          fourLabel: 'or',
          fourValue: 'or'
        }
      ], // 条件
      countNum: 1, //用于显示第一个错误
      isSearch: false, // 是否搜索
    }
  },
  watch: {
    hignModalVisible(val) {
      // console.log(val)
      // console.log(this.hignOneList)
      if (!val) {
        this.countNum = 1
        if (!this.isSearch) {
          this.$refs['reasonList'].resetFields()
          this.form.reasonList = [
            {
              oneS: '',
              twoS: 'like',
              threeS: '',
              fourS: '',
              getDicUrl: '',
              choose: {
                needInput: true
              }
            }
          ]
        }
      }
    }
  },
  methods: {
    // 字段切换
    changeOnes(item) {
      // console.log(item)
      item.getDicUrl = ''
      item.threeS = ''
      this.hignOneList.forEach(element => {
        // console.log(element)
        if (element.caseKey === item.oneS && element.needKeyValue) {
          item.getDicUrl = element.actionUrl
        }
        if (element.caseKey === item.oneS && element.isCustomList) {
          item.getDicUrl = element.isCustomList
        }
      });
      // debugger
      if (item.getDicUrl) {
        item.twoS = '='
        this.changeTwos(item)
      } else {
        item.twoS = 'like'
        this.changeTwos(item)
      }
    },
    // 验证
    validateTwo(prop, msgStatus, validateMessage) {
      // console.log(prop, msgStatus, validateMessage)
      if (!msgStatus && !this.countNum) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage)
        }
      }
    },
    // 搜索
    agreeHSearch() {
      console.log(this.form)
      this.countNum = 0;
      this.$refs.reasonList.validate((valid) => {
        if (valid) {
          const arr = []
          this.form.reasonList.forEach(element => {
            let item = element.oneS + ' ' + element.twoS + ' ' + `'${element.threeS}'` + ' ' + element.fourS
            if (element.twoS === 'like' || element.twoS === 'not like') {
              item = element.oneS + ' ' + element.twoS + ' ' + `'%${element.threeS}%'` + ' ' + element.fourS
              if ((!element.threeS && element.threeS !== 0) && !element.fourS) {
                item = element.oneS + ' ' + element.twoS
              } else if ((!element.threeS && element.threeS !== 0) && element.fourS) {
                item = element.oneS + ' ' + element.twoS + ' ' + element.fourS
              } else if ((element.threeS || element.threeS === 0) && !element.fourS) {
                item = element.oneS + ' ' + element.twoS + ' ' + `'%${element.threeS}%'`
              }
            } else {
              if ((!element.threeS && element.threeS !== 0) && !element.fourS) {
                item = element.oneS + ' ' + element.twoS
              } else if ((!element.threeS && element.threeS !== 0) && element.fourS) {
                item = element.oneS + ' ' + element.twoS + ' ' + element.fourS
              } else if ((element.threeS || element.threeS === 0) && !element.fourS) {
                item = element.oneS + ' ' + element.twoS + ' ' + `'${element.threeS}'`
              }
            }
            arr.push(item)
          });
          // console.log(this.form.reasonList)
          // console.log(arr)
          // console.log(arr.join(' '))
          this.isSearch = true
          this.$emit('searchModal', arr.join(' '));
        } else {
          return false;
        }
      });
    },
    changeTwos(item) {
      // console.log(item.twoS)
      this.twoList.forEach(element => {
        // console.log(element)
        if (item.twoS === element.twoValue) {
          item.choose = element
        }
      });
      if (item.choose.needInput == false) {
        item.threeS = ''
      }
      console.log(item)
    },
    // 删除搜索项
    delItem(item) {
      // console.log(item)
      if (this.form.reasonList.length !== 1) {
        this.form.reasonList.splice(this.form.reasonList.indexOf(item), 1)
      }
      this.form.reasonList.forEach((element, index) => {
        // console.log(index)
        // console.log(this.form.reasonList.length - 1)
        if (index === this.form.reasonList.length - 1) {
          // console.log(element)
          element.fourS = ''
        }
      });
    },
    // 增加项
    addItem() {
      this.form.reasonList.forEach(element => {
        element.fourS = 'and'
      });
      let addObj = {
        oneS: '',
        twoS: 'like',
        threeS: '',
        fourS: '',
        getDicUrl: '',
        choose: {
          needInput: true
        }
      }
      this.form.reasonList.push(addObj)
    },
    // 弹窗关闭触发
    handleClose() {
      this.$emit('cancelModal');
    },
    // 重置
    resetHSearch() {
      this.isSearch = false
      this.$refs['reasonList'].resetFields()
      this.form.reasonList = [
        {
          oneS: '',
          twoS: 'like',
          threeS: '',
          fourS: '',
          getDicUrl: '',
          choose: {
            needInput: true
          }
        }
      ]
      // console.log(this.form.reasonList)
    },
    // 关闭弹窗
    closeHSearch() {
      this.$emit('cancelModal');
    }
  }
}
</script>

<style lang="scss">
.hign-search-modal {
  .el-dialog__header {
    border-bottom: 1px solid #D4D4D7;
    padding: 11px 16px;
    .el-dialog__headerbtn {
      top: 11px;
      right: 16px;
    }
    .search-modal-title {
      .modal-title-icon {
        font-size: 12px;
      }
      .modal-title-span {
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    height: 276px !important;
    padding: 12px 16px;
    text-align: left;
    overflow-y: auto;
    .search-modal-content {
      font-size: 0;
      padding: 4px 0;
      .modal-content-form-item {
        display: inline-block;
      }
      .content-select-one {
        width: 194px;
        margin-right: 4px;
      }
      .content-select-two {
        width: 76px;
        margin-right: 4px;
        .el-input__suffix {
          right: 0;
        }
        .el-input--suffix .el-input__inner {
          padding-left: 4px;
          padding-right: 4px;
        }
      }
      .modal-content-icon {
        display: inline-block;
        .el-button {
          width: 13px;
          height: 14px;
          padding: 0 !important;
          margin-left: 0px !important;
        }
        .el-button--medium {
          border-radius: 2px;
        }
        .el-button {
           border-radius: 2px;
        }
        .content-icon-del {
          border: 1px solid #FF3B30;
          color: #FF3B30;
        }
        .content-icon-add {
          margin-left: 16px !important;
          border: 1px solid #3296FA;
          color: #3296FA;
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #D4D4D7;
    padding: 8px 16px 16px 16px;
    .search-modal-footer {
      font-size: 0;
      .hign-footer-notice {
        color: #AEAEB4;
        font-size: 12px;
        float: left;
        line-height: 28px;
      }
      .el-button {
        margin-left: 8px !important;
      }
      .modal-footer-two {
        height: 28px;
      }
    }
  }
}
</style>
